let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("adHkK")).then(() => parcelRequire('fhoyL'));